import {isValid,
    addYears, addMonths, addWeeks, addDays, addHours, addMinutes, addSeconds,
    startOfYear, endOfYear, startOfMonth, startOfWeek, endOfWeek, endOfMonth, startOfDay, endOfDay
} from "date-fns";
import {toDate} from 'date-fns-tz'

const offsetFunctionMap = {Y: addYears, M: addMonths, W: addWeeks, D: addDays, h: addHours, m: addMinutes, s: addSeconds}
const paddingFunctionMap = {
    start: {Y: startOfYear, M: startOfMonth, W: startOfWeek, D: startOfDay},
    end: {Y: endOfYear, M: endOfMonth, W: endOfWeek, D: endOfDay}
}
const validCalcRegex = /^now((?:(?:[-+][1-9])+[YMWDhms])*)(?::([YMWD]))?$/
export default function(template, paddingDirection) {
    return Object.freeze({
        definition() {
            return template
        },
        value() {
            const directParse = toDate(template)
            if (isValid(directParse)) return directParse

            const matches = validCalcRegex.exec(template)
            if (!matches) return new Date(NaN)

            const offsets = matches[1]
            const bound = matches[2]

            let date = startOfDay(new Date())

            let number = ''
            let state = 'operator'
            for (let i = 0; i < offsets.length; ++i) {
                if (state === 'operator') {
                    number = offsets[i]
                    state = 'number'
                } else if (state === 'number') {
                    if (!isNaN(offsets[i])) number += offsets[i]
                    else {
                        date = offsetFunctionMap[offsets[i]](date, parseInt(number))
                        state = 'operator'
                    }
                }
            }

            if (bound) date = paddingFunctionMap[paddingDirection][bound](date)

            return date
        }
    })
}
